import { LoadingButton } from '@mui/lab';
import {
  Alert,
  FormHelperText,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { setAutocolonSelectItem } from 'app/actions/transport';
import { Scrollbar } from 'app/components';
import {
  autocolonNotSelectedItemsTransportSelector,
  autocolonSelectedItemTransportSelector,
  divisionItemsTransportSelector,
} from 'app/selectors/transport';
import { useAsyncAction } from 'app/services';
import { deleteDivisionAutocolon, updateDivisionAutocolon } from 'app/store/transport';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const DivisionAutocolonEditBlock = () => {
  const [isUpdate, setIsUpdate] = useState(false);
  const dispatch = useDispatch();
  const autocolonSelectedItem = useSelector(autocolonSelectedItemTransportSelector);
  const autocolons = useSelector(autocolonNotSelectedItemsTransportSelector);
  const divisions = useSelector(divisionItemsTransportSelector);

  const [selectedDivision, setSelectedDivision] = useState(null);
  const [name, setName] = useState(null);
  const [type, setType] = useState(null);
  const [selectedAutocolons, setSelectedAutocolons] = useState([]);
  const [unselectedAutocolons, setUnselectedAutocolons] = useState([]);
  const handleChangeDivision = (e) => {
    setIsUpdate(true);
    setSelectedDivision(e.target.value);
  };
  const handleChangeName = (e) => {
    setIsUpdate(true);
    setName(e.target.value);
  };

  const {
    asyncAction: updateAutocolon,
    isLoading: isUpdateAutocolonLoading,
    isSuccessful: isUpdateAutocolonSuccessful,
    isError: isUpdateAutocolonError,
  } = useAsyncAction(updateDivisionAutocolon, [autocolonSelectedItem]);
  const {
    asyncAction: deleteAutocolon,
    isLoading: isDeleteAutocolonLoading,
    isSuccessful: isDeleteAutocolonSuccessful,
    isError: isDeleteAutocolonError,
  } = useAsyncAction(deleteDivisionAutocolon, [autocolonSelectedItem]);

  useEffect(() => {
    if (!autocolonSelectedItem) return;
    setName(autocolonSelectedItem.name);
    if (autocolonSelectedItem.autocolons && !autocolonSelectedItem.id_division) {
      setType('division');
      setSelectedAutocolons(autocolonSelectedItem.autocolons);
    } else {
      setType('autocolon');
      setSelectedDivision(autocolonSelectedItem.id_division);
    }
  }, [autocolonSelectedItem]);

  const handleDelete = () => {
    deleteAutocolon({
      id: autocolonSelectedItem.id,
      type,
      selectedAutocolons,
    });
    setIsUpdate(false);
  };
  const handleUpdateAutocolon = () => {
    updateAutocolon({
      name,
      id_division: selectedDivision,
      id: autocolonSelectedItem.id,
      type,
      selectedAutocolons,
      unselectedAutocolons,
    });
    setIsUpdate(false);
  };
  useEffect(() => {
    if (isDeleteAutocolonSuccessful) {
      dispatch(setAutocolonSelectItem(null));
    }
  }, [isDeleteAutocolonSuccessful]);

  const newAutocolons = () => {
    const selectedAutocolonsIds = selectedAutocolons.map((item) => item.id);
    return autocolons.filter((autocolon) => !selectedAutocolonsIds.includes(autocolon.id));
  };
  const handleToggleAutocolon = ({ id, name }) => {
    setIsUpdate(true);
    if (selectedAutocolons.find((item) => item.id === id)) {
      setSelectedAutocolons(selectedAutocolons.filter((item) => item.id !== id));
      if (!autocolons.find((autocolon) => autocolon.id === id)) {
        setUnselectedAutocolons([...unselectedAutocolons, { id, name }]);
      }
      return;
    }
    setSelectedAutocolons([...selectedAutocolons, { id, name }]);
    if (unselectedAutocolons.find((autocolon) => autocolon.id === id)) {
      setUnselectedAutocolons(unselectedAutocolons.filter((item) => item.id !== id));
    }
  };

  return (
    <Scrollbar>
      <Stack
        direction='column'
        alignItems='center'
        sx={(theme) => ({
          maxWidth: '540px',
          margin: '0 auto',
          width: '100%',
          padding: theme.spacing(2),
          position: 'relative',
          border: '1px solid',
          borderRadius: theme.shape.borderRadius,
          borderColor: theme.palette.divider,
          bgcolor: 'background.paper',
          '.MuiTabPanel-root': {
            width: '100%',
            padding: theme.spacing(2),
          },
          '& .MuiOutlinedInput-notchedOutline': {
            legend: {
              overflow: 'visible',
              span: {
                opacity: 1,
                bgcolor: '#fff',
              },
            },
          },
          '& .MuiTypography-root': {
            fontSize: '0.8em',
          },
          '& .MuiListItemText-root': {
            padding: 0,
            margin: 0,
          },
          '& .MuiListItemButton-root': {
            padding: '4px 0',
          },
        })}>
        {type === 'autocolon' && (
          <>
            <Stack sx={{ paddingTop: '10px', width: '100%' }}>
              <OutlinedInput
                label='Автоколонна'
                variant='outlined'
                notched
                fullWidth
                value={name}
                onChange={handleChangeName}
                placeholder='Название Автоколонны'></OutlinedInput>
              <FormHelperText>Используйте в названии не менее 3 символов</FormHelperText>
            </Stack>
            <Stack sx={{ paddingTop: '10px', width: '100%' }}>
              <Select value={selectedDivision} label='Дивизион' variant='outlined' notched fullWidth onChange={handleChangeDivision}>
                <MenuItem value={0} key={0}>
                  Отвязать отовсех
                </MenuItem>
                {divisions.map((division) => (
                  <MenuItem value={division.id} key={division.id}>
                    {division.name}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          </>
        )}

        {type === 'division' && (
          <>
            <Stack sx={{ paddingTop: '10px', width: '100%' }}>
              <OutlinedInput
                label='Дивизион'
                variant='outlined'
                notched
                fullWidth
                value={name}
                onChange={handleChangeName}
                placeholder='Название Дивизиона'></OutlinedInput>
              <FormHelperText>Используйте в названии не менее 3 символов</FormHelperText>
            </Stack>
            <Stack direction={'row'} sx={{ width: '100%', marginLeft: '2px' }}>
              <Stack sx={{ paddingTop: '10px', width: '50%' }}>
                <Typography align='left' color='text.secondary' variant='caption' component='div'>
                  Привязанные автоколонны
                </Typography>
                <List>
                  {selectedAutocolons.map(({ id, name }) => {
                    return (
                      <ListItemButton
                        key={id}
                        onClick={() =>
                          handleToggleAutocolon({
                            id,
                            name,
                          })
                        }>
                        <ListItemText primary={name} />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Stack>
              <Stack sx={{ paddingTop: '10px', width: '50%' }}>
                <Typography align='left' color='text.secondary' variant='caption' component='div'>
                  Нераспределенные автоколонны
                </Typography>
                <List>
                  {unselectedAutocolons.map(({ id, name }) => {
                    return (
                      <ListItemButton
                        key={id}
                        onClick={() =>
                          handleToggleAutocolon({
                            id,
                            name,
                          })
                        }>
                        <ListItemText primary={name} />
                      </ListItemButton>
                    );
                  })}
                  {newAutocolons().map(({ id, name }) => {
                    return (
                      <ListItemButton
                        key={id}
                        onClick={() =>
                          handleToggleAutocolon({
                            id,
                            name,
                          })
                        }>
                        <ListItemText primary={name} />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Stack>
            </Stack>
          </>
        )}
        <Stack sx={{ paddingTop: '10px', width: '100%' }}>
          {((!isUpdateAutocolonLoading && isUpdateAutocolonError) || (!isDeleteAutocolonLoading && isDeleteAutocolonError)) && (
            <Alert severity='error'>
              Произошла ошибка при
              {isUpdateAutocolonError && 'обвновлении'}
              {isDeleteAutocolonError && 'удалении'}. Попробуйте снова или обратитесь в техническую поддержку.
            </Alert>
          )}
          {!isUpdateAutocolonLoading && isUpdateAutocolonSuccessful && <Alert severity='success'>Данные успешно изменены.</Alert>}
        </Stack>
        <Stack
          direction='row'
          sx={{
            justifyContent: 'space-between',
            paddingTop: '20px',
            width: '100%',
          }}>
          <LoadingButton
            variant='contained'
            color='error'
            loading={isDeleteAutocolonLoading || isUpdateAutocolonLoading}
            onClick={handleDelete}
            disableElevation>
            Удалить
          </LoadingButton>
          <LoadingButton
            variant='contained'
            disabled={!isUpdate}
            loading={isUpdateAutocolonLoading || isDeleteAutocolonLoading}
            disableElevation
            onClick={handleUpdateAutocolon}>
            Сохранить изменения
          </LoadingButton>
        </Stack>
      </Stack>
    </Scrollbar>
  );
};

export default DivisionAutocolonEditBlock;
